export const meal=[
    {
      "quantity":1,
      "id":25,
    "name":"All Chicken Box",
    "detail":"A Box with your favorites! Get 1 pc Hot & Crispy, 2 Hot Wings & 1 Chicken Strip at a deal price",
    "price":189.52,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002167.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":26,
    "name":"Zinger Tandoori Box",
    "detail":"A deal for the Tandoori lovers : Get 1 Tandoori Zinger, 2 Hot Wings, 1 Veg Patty & Pepsi",
    "price":313.33,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001003.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":27,
    "name":"Popcorn Biryani Box",
    "detail":"Biryani lovers unite : Get 1 Popcorn Biryani Bucket with gravy, 2 Hot Wings & Pepsi",
    "price":328.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001039.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":28,
    "name":"Veg Zinger Box",
    "detail":"A deal for the Veg Zinger lovers : Get 1 Veg Zinger, 2 Veg Patties & a Pepsi",
    "price":313.33,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001004.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":29,
    "name":"Veg Biryani Box",
    "detail":"Biryani lovers unite : Get 1 Veg Biryani Bucket with gravy, 1 Veg Patty & a Pepsi",
    "price":279.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00001038.jpg?ver=20.85"
    }
    ];